import { redirect, RouteObject } from 'react-router-dom';

import i18n from 'app/i18n';
import { clients } from 'app/services';
import { ModuleLayout } from 'app/layouts';

import Form from './form';
import List from './list';

export const routes: RouteObject[] = [
  { path: 'clients', element: <ModuleLayout />,
    handle: { title: i18n.t('clients.title') },
    children: [
      { path: '', index: true, element: <List />,
        handle: { permission: 'clients:read', exclude: true },
      },
      { path: 'new', element: <Form />,
        handle: { title: i18n.t('clients.new'), permission: 'clients:create' },
      },
      { path: ':id', element: <Form />,
        loader: ({ params: { id } }) => clients.get(id!).then(({ data }) => data ?? redirect('..')),
        handle: { title: (client: any) => (client && i18n.t('clients.edit', client)), permission: 'clients:update' },
      },
    ],
  },
];
